var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"qrcode",attrs:{"id":'qrcode_' + _vm.idName}}),(_vm.qrText)?_c('div',[_vm._v(_vm._s(_vm.qrText))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }